import { Box } from "@mui/material";
import { BankConnectionRankingPageContent } from "Components/BankRanking/BankConnectionRankingPageContent";
import { AnonymousLayout } from "Components/Layout/AnonymousLayout";
import { PageTitle } from "Components/Shared/PageTitles/PageTitle";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { Resources, useResource } from "Translations/Resources";

const AnonymousBankConnectionRankingPage = () => {
  const { t } = useResource();

  return (
    <AnonymousLayout title={t(Resources.BankRating.Title)}>
      <StyledPageWrapper>
        <Box mb={3}>
          <PageTitle
            title={t(Resources.BankRating.Title)}
            backNavigation={{
              mode: "historyStack",
              fallbackUrl: null,
            }}
          />
        </Box>
        <Box className="left-content">
          <BankConnectionRankingPageContent />
        </Box>
      </StyledPageWrapper>
    </AnonymousLayout>
  );
};

export default AnonymousBankConnectionRankingPage;
